import { useEffect, useState } from 'react';
import { confirmDialog, type ConfirmOptions } from '@/lib/confirmDialog';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type State = (ConfirmOptions & { resolve: (confirmed: boolean) => void }) | null;

export function ConfirmDialogProvider() {
  const [state, setState] = useState<State>(null);

  useEffect(() => {
    confirmDialog.subscribe((request) => setState(request));
    return () => confirmDialog.unsubscribe();
  }, []);

  const handleConfirm = () => {
    state?.resolve(true);
    setState(null);
  };

  const handleCancel = () => {
    state?.resolve(false);
    setState(null);
  };

  return (
    <Dialog open={state !== null} onOpenChange={(open) => { if (!open) handleCancel(); }}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>{state?.title}</DialogTitle>
          {state?.text && <DialogDescription>{state.text}</DialogDescription>}
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            {state?.cancelButtonText ?? 'Cancelar'}
          </Button>
          <Button onClick={handleConfirm}>
            {state?.confirmButtonText ?? 'Confirmar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
